export default {
  copySuccess: "Copy successful",
  copyFail: "Copy fails, please try to copy manually",
  foot: {
    termsOfService: "Điều khoản hội viên",
    privacyPolicy: "Điều khoản bảo mật",
    Notice: "",
    EmailText: "Mail CSKH:",
    info: "© NEXON Korea Corp.All Rights Reserved ",
    info1: "Công ty Cổ phần Wetaps ",
    info2: "Địa chỉ: 22 Hồng Hà, Phường 2, Quận Tân Bình, TP Hồ Chí Minh ",
    info3:
      "Bản quyền trò chơi thuộc về Rastar Games (HK) Co., Ltd và Công ty Cổ phần Wetaps phân phối độc quyền tại Việt Nam ",
    info4:
      "Quyết định phê duyệt kịch bản phát hành trò chơi số 2143/QĐ-BTTTT do Bộ TTTT cấp ngày 06 tháng 11 năm 2023",
    rotwilightsea:
      "© Gravity Co., LTD & Lee MyoungJin(studio DTDS). All Rights Reserved.",
    tkingdomssea:
      "Copyright© 2025 RASTAR GAMES (HK) CO., Ltd. All Rights Reserved",
  },
  notFound: {
    title: "Trang bạn đang cố truy cập không tìm thấy...",
    content:
      "Sẽ sớm rời khỏi trang này, Sẽ tự động quay lại trang chủ trong vòng ",
    content2: " giây",
    btn: "Quay lại trang chủ",
  },
};
